/* global history, location */

const handleHash = {
  parseHash(hash) {
    if (hash.length > 0 && typeof hash === 'string') {
      return hash.slice(1, hash.length).split(',').map(e => parseInt(e, 10))
    }
    return null
  },
  encodeHash(array) {
    return `#${array.join(',')}`
  },
  getHash() {
    return window.location.hash
  },
  setHash(hash) {
    if (history.pushState) {
      history.pushState(null, null, hash)
    } else {
      location.hash = hash
    }
  }
}

export default handleHash



// WEBPACK FOOTER //
// ./src/helpers/handleHash.js